var exports = {
  "kL": "x0a7806d5--f6369c--container",
  "p_": "x0a7806d5--f6369c--list",
  "x3": "x0a7806d5--f6369c--list-item",
};

module.exports = exports;
